import styled from 'styled-components';
import { mediaQuery, PrimaryButton } from 'components';
import * as Colors from 'constants/colors';

export const ProductNavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 1rem;
  padding: 2rem 2rem 1rem 0;

  ${mediaQuery.medium`
    justify-content: flex-end;
  `}

  ${mediaQuery.medium`
    justify-content: flex-end;
    padding-right: 3rem;
`}

  /* Page Limit Select Component Styling */
  > div > div {
    font-size: 14px;
    text-transform: uppercase;
    width: 7.7rem;
    margin: 0;

    ${mediaQuery.medium`
      margin-right: 1.5rem;
    `};
  }
`;

export const PaginationWrapper = styled.div`
  font-size: 14px;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-end;
  a[disabled] {
    pointer-events: none;
  }
`;

export const PaginationNavLink = styled.a<{ disabled: boolean }>`
  color: ${({ disabled }) => (disabled ? Colors.LIGHT_GRAY : Colors.BLACK)} !important;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  &:hover {
    border-bottom: ${({ disabled }) => (!disabled && `1px solid ${Colors.BLACK}`)};
    font-weight: ${({ disabled }) => (!disabled && 'bold')};
  }

  &:first-of-type {
    margin-right: 10px;
  }
`;

export const PageLink = styled.a<{ active: boolean}>`
  padding: 0 2.5px;
  margin-right: 10px;
  color: ${Colors.BLACK} !important;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')} !important;
  border-bottom: ${({ active }) => active && `1px solid ${Colors.BLACK}`} !important;
  
  &:hover {
    cursor: ${({ active }) => (active ? 'default' : 'pointer')};
    border-bottom: 1px solid ${Colors.BLACK};
    font-weight: bold !important;
  }

  ${mediaQuery.medium`
    margin-right: 13px;
  `};
`;

export const StyledSpan = styled.span`
  margin-left: -7px;
  margin-right: 6px;
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const LoadMoreButton = styled(PrimaryButton)`
  background-color: white !important;
  border-radius: 80px;
  width: fit-content;
  background: white;
  color: black;
  border: 0.5px solid #000000;
  padding: 0.6rem 2.5rem;
`;
